import { cn } from '@/lib/utils';

const sizeHeights = {
  sm: 'h-8 max-h-8',
  md: 'h-10 max-h-10',
  lg: 'h-14 max-h-14',
  xl: 'h-[16rem] max-h-[16rem]',
  /** Sidebar / nav rail — width-driven so the mark can fill the rail width */
  sidebar: 'h-auto max-h-none',
} as const;

export type BrandLogoProps = {
  className?: string;
  /** Accessible label; use empty string when decorative next to visible brand text */
  alt?: string;
  size?: keyof typeof sizeHeights;
};

export function BrandLogo({ className, alt = '', size = 'md' }: BrandLogoProps) {
  return (
    <img
      src="/logo.svg"
      alt={alt}
      decoding="async"
      className={cn(
        'w-auto shrink-0 object-contain object-left',
        sizeHeights[size],
        className,
      )}
    />
  );
}
